export const HOME_PATH = '/';

// Error
export const NOT_FOUND_PATH = '/pages/error-404';

// Non authenticated pages
export const ACCOUNT_PATH = '/account';
export const LOGIN_PATH = '/account/login';
export const SIGN_UP_PATH = '/account/signup';
export const REGISTER_PATH = '/account/register';
export const LOGOUT_PATH = '/account/logout';
export const FORGET_PASSWORD_PATH = '/account/forget-password';
export const FORGOT_PASSWORD_PATH = '/account/forgot-password';

// Error page
export const ERROR_PAGE_PATH = '/error';

// Dashboards
export const DASHBOARDS_PATH = '/dashboards';

// Bulk Operations
export const BULK_OPERATIONS_PATH = '/bulk-operations';

// Clients
export const CLIENT_LIST_PATH = '/clients';
export const ADD_CLIENT_PATH = '/clients/add';
export const EDIT_CLIENT_PATH = '/clients/edit';

// Value Propositions
export const VALUE_PROPOSITIONS_LIST_PATH = '/value-propositions';
export const ADD_VALUE_PROPOSITION_PATH = '/value-propositions/add';
export const EDIT_VALUE_PROPOSITION_PATH = '/value-propositions/edit';

export const SHARED_VALUE_PROPOSITION_PATH = '/value-propositions/shared/:sharedKey';
// Share Link: the public, resettable address of a Public VP (not the Invite Link above).
export const VP_SHARE_LINK_PREFIX = '/vp/shared';
export const VP_SHARE_LINK_PATH = `${VP_SHARE_LINK_PREFIX}/:shareKey`;

// VPX
export const VPX_LIST_PATH = '/vpx';
export const VPX_USER_PROFILE_PATH = '/vpx/user-profile';
export const VPX_ORGANIZATION_PROFILE_PATH = '/vpx/organization-profile';

export const VPX_INVITATION_LIST_PATH = '/invitation/vpx/list';
export const VPX_INVITATION_PUBLIC_PATH = '/invitation/vpx/public';
export const VPX_INVITATION_PRIVATE_PATH = '/invitation/vpx/private';

// Fundamentals
export const FUNDAMENTALS_LIST_PATH = '/fundamentals';
export const ADD_FUNDAMENTALS_PATH = '/fundamentals/add';
export const EDIT_FUNDAMENTALS_PATH = '/fundamentals/edit';

// Profile
export const SHARED_USER_PROFILE_PATH = '/profile/shared/:shareKey';
export const PROFILE_SECURITY_PATH = '/profile/security';
export const PROFILE_PERSONAL_INFORMATION_PATH = '/profile/information';
export const PROFILE_SUBSCRIPTION_PATH = '/profile/subscription';
export const PROFILE_PATH = PROFILE_PERSONAL_INFORMATION_PATH;

export const SUBSCRIPTION_EXPIRED_PATH = '/subscription-expired';

export const PAYMENT_SUCCESS_PATH = '/paymentsuccess';

// Organization
export const ORGANIZATION_ORGANIZATION_PATH = '/organization';
export const ORGANIZATION_NON_EXISTENT_ORGANIZATION_PATH = '/non-existent-organization';
export const ORGANIZATION_DASHBOARD_PATH = '/organization/dashboard';
export const ORGANIZATION_EDIT_ORGANIZATION_DETAILS_PATH = '/organization/details/edit';
export const ORGANIZATION_CREATE_ORGANIZATION = '/organization/create';
export const ORGANIZATION_LIST_ORGANIZATION_INVITES = '/organization/list-invites';
export const ORGANIZATION_CLIENTS_PATH = '/organization/clients';
export const ORGANIZATION_ADD_ORGANIZATION_CLIENT_PATH = '/organization/clients/add';
export const ORGANIZATION_EDIT_ORGANIZATION_CLIENT_PATH = '/organization/clients/edit';
export const ORGANIZATION_USERS_PATH = '/organization/users';
export const ORGANIZATION_VALUE_PROPOSITIONS_PATH = '/organization/value-propositions';
export const ORGANIZATION_LICENSE_CHANGE_CONFIRM_PATH = '/organization/license-change-confirm';
export const CONFIRM_ORGANIZATION_INVITATION = '/organization/confirm-organization-invitation';
export const ORGANIZATION_REACTIVATE_PATH = '/organization/reactivate';

export const ORGANIZATION_LICENSE_STRIP_PURCHASE_SUCCESS =
  '/organization/license-strip-purchase-success';
export const ORGANIZATION_LICENSE_STRIP_PURCHASE_CANCEL =
  '/organization/license-strip-purchase-cancel';

/** Stripe success/cancel URLs from API OrganizationController.BuildStripeSession (BaseUrl + segment). */
export const ORGANIZATION_STRIPE_PAYMENT_SUCCESS_PATH = '/OrganizationPaymentSuccess';
export const ORGANIZATION_STRIPE_PAYMENT_CANCEL_PATH = '/OrganizationPaymentCancel';

// Admin paths
export const ADMIN_INVITE_NEW_USERS = '/invite-users';
export const SYSTEM_ADMIN_PATH = '/system-admin';

//Landing Page
export const LANDING_PAGE_PATH = '/landing-page';
